import { api, unwrap } from "./httpClient";
import type { Order } from "../types/api";

export interface CreateOrderPayload {
  symbol: string;
  side: "BUY" | "SELL";
  type: "MARKET" | "LIMIT" | "STOP_LIMIT";
  quantity: number;
  price?: number;
  stopPrice?: number;
  stopLoss?: number;
  takeProfit?: number;
}

export const listOrders = () =>
  unwrap<Order[]>(api({ method: "GET", url: "/orders" }));

export const listOpenOrders = () =>
  unwrap<Order[]>(api({ method: "GET", url: "/orders/open" }));

export const createOrder = async (payload: CreateOrderPayload) => {
  try {
    return await unwrap<Order>(
      api({ method: "POST", url: "/orders", data: payload })
    );
  } catch (error) {
    const message =
      typeof error === "string"
        ? error
        : error instanceof Error
        ? error.message
        : "Impossible de créer l'ordre.";
    throw message;
  }
};

export const cancelOrder = (orderId: number) =>
  unwrap<Order>(api({ method: "DELETE", url: `/orders/${orderId}` }));
